import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

export interface PowerBIDashboardResponse {
  data: {
    iframeUrl: string;
    accessToken: string;
    reportId: string;
    expiration: string;
    filtroEmpresa: string | null;
    filtroInstituicaoEnsino: string | null;
  };
  retorno: {
    codigo: number;
    mensagem: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class PowerBIDashboardService {
  // Trata barra final no environment.apiUrl para evitar // duplos
  private baseUrl = environment.apiUrl.endsWith('/') ? environment.apiUrl.slice(0, -1) : environment.apiUrl;
  private apiUrl = `${this.baseUrl}/profissionais/dashboard/iframe-url`;

  constructor(private http: HttpClient) {}

  obterConfiguracao(empresa?: string, instituicaoEnsino?: string): Observable<PowerBIDashboardResponse> {
    let params = new HttpParams();
    if (empresa) params = params.set('empresa', empresa);
    if (instituicaoEnsino) params = params.set('instituicaoEnsino', instituicaoEnsino);

    return this.http.get<PowerBIDashboardResponse>(this.apiUrl, { params });
  }
}
